// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"154efbfb","176":"154efbfb","449":"154efbfb","634":"26870b8b","852":"154efbfb"}[chunkId] + ".chunk.css";
};